import axios from 'axios';

import { API_URL } from 'v3/api/core/apiConfig';

export const axiosInstance = axios.create({
  baseURL: `${API_URL}api/`,
  timeout: 25000,
});
